// Module
var code = "<button class=\"vui-edit-btn\"\n        type=\"button\"\n        ng-click=\"$ctrl.onClick($event)\"\n        data-ng-disabled=\"$ctrl.disabled\"\n        ng-transclude>\n</button>\n";
// Exports
module.exports = code;